import { render, staticRenderFns } from "./DesignDetail.vue?vue&type=template&id=22393980&scoped=true"
import script from "./DesignDetail.vue?vue&type=script&lang=js"
export * from "./DesignDetail.vue?vue&type=script&lang=js"
import style0 from "./DesignDetail.vue?vue&type=style&index=0&id=22393980&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22393980",
  null
  
)

export default component.exports